<script>
  import Photos from './Photos.svelte';
  import { geocoderResult, slidesTracker, data, divisionsArray, issueData, tileData, issues, issueChoices} from '../stores.js';

  import { createMap, createAssemblySenateMap, takeScreenshot } from '../map.js';
  import { onMount } from 'svelte';
  import { openFeedbackForm } from '../feedbackform';
  import { csv } from 'd3-fetch';
  import { __, __c } from '../utils/i18n';

  const logurl = window.DATA_URLS.update_log;

  async function csvParse(c) {
    const data = await csv(c);
    return data.reverse();
  }
  
  $: changelog = csvParse(logurl)
  
  export let feed;

  let showAll = false;  
  function onToggle() {
    showAll = !showAll;
  }

  onMount(() => {

    createMap(
      $geocoderResult.center,
      feed.locality.id,
      feed.county.id,
      feed.state.assembly.id,
      feed.state.state_senate.id,
      feed.federal.id
    );


    // get photo of combo map
    let screenshotButton = document.querySelector('#map-screenshot');
    screenshotButton.addEventListener('click', function (e) {
      takeScreenshot();
    });

  });
</script>
<div class="section snapshot">
  <div class="header">
    <h1>{__("Here's what your L.A. looks like!")}</h1>
    <button class="action" id="map-screenshot">{__('Download Your Shapes')}</button>
  </div>
  <div class="mapbox-snapshot-container">
    <div id="map" />
  </div>
</div>

<div class="hidden" aria-hidden="true">
  <canvas id="result" aria-hidden="true"></canvas>
</div>

<div class="section about" id="about-section">
<div>
  <h2>
    {__("About this project")}
  </h2>
  <p>
    {__("This project was created to help Angelenos learn more about their local government and institutions that affect their day-to-day lives.")}
  </p>
  <p>
    {__("Engaging with bureaucracy can feel confusing and intimidating. We hope this tool will help you untangle some of its complexities and encourage you to get your voice heard.")}
  </p>
  <p>
    {@html __('The Shape Your LA team includes <a href="https://www.latimes.com/people/vanessa-martinez">Vanessa Martínez</a> and <a href="https://www.latimes.com/people/hanna-sender">Hanna Sender</a>. Times staffers <a href="https://www.latimes.com/people/phil-willon">Phil Willon</a>, <a href="https://www.latimes.com/people/jaclyn-cosgrove">Jaclyn Cosgrove</a>, <a href="https://www.latimes.com/people/jon-healey">Jon Healey</a>, <a href="https://www.latimes.com/people/benjamin-oreskes">Ben Oreskes</a>, <a href="https://www.latimes.com/people/doug-smith">Doug Smith</a>, <a href="https://www.latimes.com/people/szu-yu-chen">Szu Yu Chen</a>, <a href="https://www.latimes.com/people/katie-licari">Katie Licari</a>, <a href="https://www.latimes.com/people/ana-elena-azpurua">Ana Elena Azpúrua</a>, <a href="https://www.latimes.com/people/phi-do">Phi Do</a>, <a href="https://www.latimes.com/people/koko-nakajima">Koko Nakajima</a> and <a href="https://www.latimes.com/people/hailey-wang">Hailey Wang</a> contributed reporting. Illustrations created by <a href="https://joannaneborsky.com/">Joanna Neborsky</a>.')}
  </p> 

  <p>
    {@html __('This project was created by <a href="https://www.latimes.com/people/matthew-ballinger">Matt Ballinger</a>, <a href="https://www.latimes.com/people/iris-lee">Iris Lee</a>, <a href="https://www.latimes.com/people/vanessa-martinez">Vanessa Martínez</a>, <a href="https://www.latimes.com/people/joy-park">Joy Park</a>, <a href="https://www.latimes.com/people/alex-tatusian">Alex Tatusian</a> and <a href="https://www.latimes.com/people/hanna-sender">Hanna Sender</a>.')}
  </p>

  <p>
    {@html __('It was edited by Matt Ballinger and copy edited by Don Ragland. <a href="https://www.latimes.com/people/seth-liss">Seth Liss</a> planned the promotion and engagement. Marketing by Christina Wong, Katie Gray and Brandon Sides. Additional digital help from Lora Victorio, Beto Alvarez, <a href="https://www.latimes.com/people/daniel-gaines">Daniel Gaines</a>, <a href="https://www.latimes.com/people/lorena-iniguez-elebee">Lorena Iñiguez Elebee</a>, <a href="https://www.latimes.com/people/sandhya-kambhampati">Sandhya Kambhampati</a>, <a herf="https://www.latimes.com/people/aida-ylanan">Aida Ylanan</a>, <a herf="https://www.latimes.com/people/katie-licari">Katie Licari</a>, <a href="https://www.latimes.com/people/george-levines">George Levines</a>, <a href="https://www.latimes.com/people/sean-greene">Sean Greene</a>, James Tyner, Clint Fisher and Alan Nguyen. Photo of Gavin Newsom is by AP Photo/Rich Pedroncelli.')}
  </p>

  <p>{@html __('District and representative information are provided by Times reporting and <a href="https://developers.google.com/civic-information">Google Civic Information</a>, which returns information on local representatives based on the address provided. Maps of council and supervisor districts are provided by L.A. City and L.A. County. Maps of state Senate, Assembly and congressional districts are provided by <a href="https://www.wedrawthelinesca.org/">We Draw the Lines CA</a> and <a href="https://data.ca.gov/">California Open Data</a>. Geolocation and map base layers provided by <a href="https://www.mapbox.com/about/maps/">©Mapbox</a> and <a href="http://www.openstreetmap.org/about/">©OpenStreetMap</a>. Community garden locations and data from the <a href="http://lagardencouncil.org/">Los Angeles Community Garden Council</a> and Times reporting.')}
  </p>

  <p>{@html __('If you see information here that you believe is incorrect or out of date, please contact the team at <a href="mailto:shapeyourla@caltimes.com">shapeyourla@caltimes.com</a>.')}
  </p>
  </div>
    <Photos
      lookup='sidewalk'
      className = "main-page-img"
      idName = ""
      ariaHidden = "false"
      lazyLoad = "false"
      />
  <div>
</div>
<div class="changelog">
  <h2>
    {__("Project Updates")}
  </h2>
  <p>
    {__("This is a living project maintained by a small team at the Los Angeles Times. Below is a timeline of updates we've made since launching in October 2022.")} <a aria-label="Open feedback form" on:click={(e)=>openFeedbackForm()}>{__("If there's something you'd like to see more of, let us know!")}</a>
  </p>
  <ul class:show-more={showAll}>
    {#await changelog}
      <p />
    {:then log}
      {#each log as update, i}
        <li>
          <date>{update[`${__c('date')}`]}</date> 
          {update[`${__c('update')}`]} 
        </li>
      {/each}
    {:catch error}
      {error} 
    {/await}
   
  </ul>
  <button class="showbtn action" on:click={onToggle}>
    {showAll ? __('See less updates') : __('See all updates')}
    <div class="plus" class:minus={showAll}>
      <div class="stroke"></div>
      <div class="stroke"></div>
    </div>
  </button>
</div>
</div>